import React from 'react';
export const StorySection = () => {
  return <section className="w-full bg-white py-8 md:py-12 px-4 md:px-6" data-id="element-166">
      <div className="max-w-[720px] mx-auto" data-id="element-167">
        <h2 className="font-playfair text-[28px] md:text-[38px] text-primary text-center mb-6" data-id="element-168">
          Does This Sound Familiar?
        </h2>

        <div className="font-lato text-[16px] md:text-[17px] text-body leading-[1.8]" data-id="element-169">
          <p className="mb-5" data-id="element-170">You wake up tired. Again.</p>
          <p className="mb-5" data-id="element-171">
            You slept 8 hours, but your body feels like it never rested. Your
            mind is foggy, your stomach bloated, and before noon you're already
            counting the hours until you can go back to bed.
          </p>
          <p className="mb-5" data-id="element-172">You went to the doctor. They ran tests.</p>
          <p className="mb-5" data-id="element-173">Everything is normal, they said.</p>
          <p className="mb-5" data-id="element-174">
            But you know that's not true. You live in this body. And something
            is not right.
          </p>
        </div>

        <blockquote className="font-playfair italic text-[24px] md:text-[28px] text-primary text-center py-2 my-4 max-w-[600px] mx-auto border-none" data-id="element-175">
          "Everything is normal, they said."
        </blockquote>

        <div className="font-lato text-[16px] md:text-[17px] text-body leading-[1.8] mb-4" data-id="element-176">
          <p className="mb-5" data-id="element-177">
            Maybe you've been feeling this way for months — or years. Maybe you
            were on birth control for years and since stopping, nothing has been
            the same. Maybe your cycle is chaos, your skin is reacting, your
            mood shifts without reason and your energy disappeared without a
            trace.
          </p>
          <p className="mb-5" data-id="element-178">And the worst part isn't the symptoms.</p>
        </div>

        <div className="flex flex-col gap-2" data-id="element-179">
          <p className="font-lato font-bold text-[18px] text-medium text-left m-0 p-0" data-id="element-180">
            The worst part isn't the symptoms.
          </p>
          <p className="font-lato font-bold text-[18px] text-medium text-left m-0 p-0" data-id="element-181">
            The worst part is that nobody takes you seriously.
          </p>
        </div>
      </div>
    </section>;
};